import ethereumIcon from "../assests/overlay/ethereum-icon.svg";
import gnosisIcon from "../assests/overlay/gnois-icon.svg";
import baseIcon from "../assests/overlay/base-icon.svg";

export const useWalletInApp = false; //disable inAppWallet on web as any existing extension will conflict with chrome?.runtime?.sendMessage??? All web users should use extension

export const supportedChainsIds =
  process.env.REACT_APP_NODE_ENV === "production" ? [1, 8453] : [11155111, 100];

export const ChainConfig = {
  1: {
    chainId: `0x${Number(1).toString(16)}`,
    chainName: "Ethereum",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: [
      `https://eth-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ETH_KEY}/`,
    ],
    blockExplorerUrls: ["https://etherscan.io/"],
  },

  8453: {
    chainId: `0x${Number(8453).toString(16)}`,
    chainName: "Base Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: [
      `https://base-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
    ],
    blockExplorerUrls: ["https://basescan.org/"],
  },

  100: {
    chainId: `0x${Number(100).toString(16)}`,
    chainName: "Gnosis",
    nativeCurrency: {
      name: "XDAI",
      symbol: "XDAI",
      decimals: 18,
    },
    rpcUrls: ["https://rpc.gnosischain.com/"],
    blockExplorerUrls: ["https://gnosisscan.io/"],
  },

  11155111: {
    chainId: `0x${Number(11155111).toString(16)}`,
    chainName: "Sepolia Test Network",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: [
      `https://eth-sepolia.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
    ],
    blockExplorerUrls: ["https://sepolia.etherscan.io/"],
  },

  84532: {
    chainId: `0x${Number(11155111).toString(16)}`,
    chainName: "Base Sepolia",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: ["https://sepolia.base.org"],
    blockExplorerUrls: ["https://sepolia.basescan.org/"],
  },
};

export const chainDetails = {
  //default chain when users are not connected to fetch and display data
  //TODO: change default chain subgraph urls from sepolia to mainnet urls during production.
  0:
    process.env.REACT_APP_NODE_ENV === "production"
      ? {
          chainId: 8453,
          icon: baseIcon,
          name: "Base Mainnet",
          vaultSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/HESgHTG2RE8F74MymKrdXKJw2u4s8YBJgbCjHuzhpXeC`,
          walletSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/2aGD2WDR6ncrTvGU4wEaME2Ywke1ookuNucMNJmcnrz5`,
          rpcUrls: [
            `https://base-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
          ],
          usdc: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
          spotCustodian: "",
          hexTrustNativeTokenId: "8453_ETH",
          hexTrustTimeout: 2100000,
          verifiedWalletChainId: 8453,
          paymentTokens: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
          explorerApiKey: "M8SGUPC8CXRTER5GGTSSXW7C9A1ZINWWYA",
          explorerApiUrl: "https://api.etherscan.io/v2/api",
          nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
          },
          brokerages: {
            HYPERLIQUID: "0xa998a4ee87346150a7cc97e6e61233af11926b57",
          },
          cfdEscrow: "0xD6021D0C9f19170347bFE19d869CA0f5feAA1c3C",
          invalidPoolIds: [
            "0x051df62bf4ab0c1a2326d40c5d4a6b94801b0d88000000000000000000000206",
            "0xdd7d818b0fd2f9aac2288a9351d306488ea72308000000000000000000000205",
            "0xe3512f38bd1b683c8d5bc0ebc53ea3c60e1f7e8d000000000000000000000203",
            "0x2bf1f285d25e6c9c9fa9639c69b07f517aae8bc40000000000000000000001f7",
            "0x8fafb750e10b5648ad1225904b9ddc09a8aea11e0000000000000000000001f6",
            "0x8d30505fbeedde498368d96bd71dec6c8ebd1fd60000000000000000000001f5",
            "0x7886c8fd17f0d00197a3e55f20b45d38f55510b30000000000000000000001f4",
            "0x6a0060ae35047e8566fd7b21189a24b9460a1df40000000000000000000001f3",
            "0x6c63beac23db73ee6cdde358766c96dd6024670e0000000000000000000001f2",
            "0xeea15968daaf2ca7fae04a25e362dfe5112422700000000000000000000001f1",
            "0xd51bf91c1752cc592875cd39bdb2cb04384f77b70000000000000000000001f0",
            "0xeed405ab9cc80e75ce9e6fb2a36f735277d8d8450000000000000000000001ef",
            "0x0f09e59f0c83dbf6d2b048bc3c16b8402ff016870000000000000000000001ee",
            "0x37979d85ea14873b20fc4f5584037ee7e1e0a4f70000000000000000000001b2",
            "0xb155334559f78c2e9e530d104c15a52f05dc58230000000000000000000001a5",
            "0xd9cd838c6c4dd6b17acbe968d0f5a081a799223d000000000000000000000198",
            "0xf09be0779f73531e9a7131f062b550dd8bcb5de500000000000000000000018a",
            "0x0616200429b56fadf9067362767dee8f9ea7eabc000000000000000000000187",
          ],
        }
      : {
          chainId: 11155111,
          icon: ethereumIcon,
          name: "Sepolia Test Network",
          vaultSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/BZYwDU6CtLq1GBwCaGUZBU4KcQk9CAtPDkEY4LAKfoJN`,

          walletSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/6Qxzqb6J12vxKqgaGmCopuQH6bzGhAzYz45bRzPs2EiG`,
          //"https://api.studio.thegraph.com/query/77016/test-wallet/version/latest",
          rpcUrls: [
            `https://eth-sepolia.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
          ],
          usdc: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
          spotCustodian: "0x6d837b81cb03c49a7c26699ffcc07d3641d835d2",
          hexTrustNativeTokenId: "11155111_ETH",
          hexTrustTimeout: 2100000,
          verifiedWalletChainId: 8453,
          loanBaseAddresses: [
            {
              baseToken: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
              contract: "0x4b3CBDB8FBe5fcdDF796cd42d3749f8AcD53DA73",
              comet: "0xAec1F48e02Cfb822Be958B68C7957156EB3F0b6e",
              collaterals: [
                "0xA6c8D1c55951e8AC44a0EaA959Be5Fd21cc07531",
                "0xa035b9e130F2B1AedC733eEFb1C67Ba4c503491F",
                "0x2D5ee574e710219a521449679A4A7f2B43f046ad",
              ],
              baseTokenName: "USDC",
              bondName: "VBUSD",
            },
          ],
          substreams: {
            primary: {
              substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
              substreamStartBlock: 5492879,
              substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
              substreamSpkg: "/primarypool.spkg",
              substreamModule: "map_subscriptions_per_pool",
              substreamProto: "/primarypool.proto",
              substreamMessage: "contract.v1.PrimaryPoolSubscriptionsList",
            },
            secondary: {
              substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
              substreamStartBlock: 6589966,
              substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
              substreamSpkg: "/secondarypool.spkg",
              substreamModule: "map_trades_per_pool",
              substreamProto: "/secondarypool.proto",
              substreamMessage: "contract.v1.SecondaryPoolTradeReportsList",
            },
            margin: {
              substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
              substreamStartBlock: 5492908,
              substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
              substreamSpkg: "/marginpool.spkg",
              substreamModule: "map_trades_per_pool",
              substreamProtoUrl: "/marginpool.proto",
              substreamMessage: "contract.v1.MarginPoolTradeReportsList",
            },
          },
          paymentTokens: [],
          explorerApiKey: "M8SGUPC8CXRTER5GGTSSXW7C9A1ZINWWYA",
          explorerApiUrl: "https://api.etherscan.io/v2/api",
          nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
          },
          brokerages: {
            HYPERLIQUID: "0x56eFa3AA1D26DF7856dB81aD29F19e091351eA52",
          },
          cfdEscrow: "0x7937A272add73fF8d3E956810F8E5228FdB8895F",
        },
  1: {
    chainId: 1,
    icon: ethereumIcon,
    name: "Ethereum",
    vaultSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/vault-mainnet/version/latest",
    walletSubgraphUrl: `https://api.studio.thegraph.com/query/77016/wallet-mainnet/version/latest`,
    rpcUrls: [
      `https://eth-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ETH_KEY}/`,
    ],
    usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    spotCustodian: "",
    hexTrustNativeTokenId: "1_ETH",
    hexTrustTimeout: 2100000,
    //       loanBaseAddresses: [{
    //     baseToken: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    //     contract: ""

    //   },
    //   {
    //   baseToken: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    //     contract: ""

    //   },
    //   {
    //   baseToken: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    //     contract: ""

    //   },
    //   {
    //   baseToken: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    //     contract: ""

    //   },
    //   {
    //    baseToken: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
    //     contract: ""

    //   },

    // ]
  },
  100: {
    chainId: 100,
    icon: gnosisIcon,
    name: "Gnosis",
    vaultSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/vault-gnosis/version/latest",
    walletSubgraphUrl:
      "https://api.studio.thegraph.com/query/77016/wallet-gnosis/version/latest",
    rpcUrls: ["https://rpc.gnosischain.com/"],
    spotCustodian: "",
    hexTrustNativeTokenId: "100_ETH",
    hexTrustTimeout: 2100000,
  },
  8453: {
    chainId: 8453,
    icon: baseIcon,
    name: "Base Mainnet",
    vaultSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/HESgHTG2RE8F74MymKrdXKJw2u4s8YBJgbCjHuzhpXeC`,
    walletSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/2aGD2WDR6ncrTvGU4wEaME2Ywke1ookuNucMNJmcnrz5`,
    rpcUrls: [
      `https://base-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
    ],
    usdc: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    spotCustodian: "",
    hexTrustNativeTokenId: "8453_ETH",
    hexTrustTimeout: 2100000,
    paymentTokens: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    explorerApiKey: "M8SGUPC8CXRTER5GGTSSXW7C9A1ZINWWYA",
    explorerApiUrl: "https://api.etherscan.io/v2/api",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    brokerages: {
      HYPERLIQUID: "0xa998a4ee87346150a7cc97e6e61233af11926b57",
    },
    cfdEscrow: "0xD6021D0C9f19170347bFE19d869CA0f5feAA1c3C",
    invalidPoolIds: [
      "0x051df62bf4ab0c1a2326d40c5d4a6b94801b0d88000000000000000000000206",
      "0xdd7d818b0fd2f9aac2288a9351d306488ea72308000000000000000000000205",
      "0xe3512f38bd1b683c8d5bc0ebc53ea3c60e1f7e8d000000000000000000000203",
      "0x2bf1f285d25e6c9c9fa9639c69b07f517aae8bc40000000000000000000001f7",
      "0x8fafb750e10b5648ad1225904b9ddc09a8aea11e0000000000000000000001f6",
      "0x8d30505fbeedde498368d96bd71dec6c8ebd1fd60000000000000000000001f5",
      "0x7886c8fd17f0d00197a3e55f20b45d38f55510b30000000000000000000001f4",
      "0x6a0060ae35047e8566fd7b21189a24b9460a1df40000000000000000000001f3",
      "0x6c63beac23db73ee6cdde358766c96dd6024670e0000000000000000000001f2",
      "0xeea15968daaf2ca7fae04a25e362dfe5112422700000000000000000000001f1",
      "0xd51bf91c1752cc592875cd39bdb2cb04384f77b70000000000000000000001f0",
      "0xeed405ab9cc80e75ce9e6fb2a36f735277d8d8450000000000000000000001ef",
      "0x0f09e59f0c83dbf6d2b048bc3c16b8402ff016870000000000000000000001ee",
      "0x37979d85ea14873b20fc4f5584037ee7e1e0a4f70000000000000000000001b2",
      "0xb155334559f78c2e9e530d104c15a52f05dc58230000000000000000000001a5",
      "0xd9cd838c6c4dd6b17acbe968d0f5a081a799223d000000000000000000000198",
      "0xf09be0779f73531e9a7131f062b550dd8bcb5de500000000000000000000018a",
      "0x0616200429b56fadf9067362767dee8f9ea7eabc000000000000000000000187",
    ],
  },
  11155111: {
    chainId: 11155111,
    icon: ethereumIcon,
    name: "Sepolia Test Network",
    vaultSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/BZYwDU6CtLq1GBwCaGUZBU4KcQk9CAtPDkEY4LAKfoJN`,

    walletSubgraphUrl: `https://gateway.thegraph.com/api/${process.env.REACT_APP_SUBGRAPH_KEY}/subgraphs/id/6Qxzqb6J12vxKqgaGmCopuQH6bzGhAzYz45bRzPs2EiG`,
    //"https://api.studio.thegraph.com/query/77016/test-wallet/version/latest",
    lidoAddress: "0x3e3FE7dBc6B4C189E7128855dD526361c49b40Af",
    verifiedLidoRewardAddress: "0x19836182a3786CD592523cAB7445325be26c3334",
    rpcUrls: [
      `https://eth-sepolia.g.alchemy.com/v2/${process.env.REACT_APP_BASE_KEY}/`,
    ],
    usdc: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    spotCustodian: "0x6d837b81cb03c49a7c26699ffcc07d3641d835d2",
    hexTrustNativeTokenId: "11155111_ETH",
    hexTrustTimeout: 2100000,
    loanBaseAddresses: [
      {
        baseToken: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
        contract: "0x4b3CBDB8FBe5fcdDF796cd42d3749f8AcD53DA73",
        comet: "0xAec1F48e02Cfb822Be958B68C7957156EB3F0b6e",
        collaterals: [
          "0xA6c8D1c55951e8AC44a0EaA959Be5Fd21cc07531",
          "0xa035b9e130F2B1AedC733eEFb1C67Ba4c503491F",
          "0x2D5ee574e710219a521449679A4A7f2B43f046ad",
        ],
        baseTokenName: "USDC",
        bondName: "VBUSD",
      },
    ],
    substreams: {
      primary: {
        substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
        substreamStartBlock: 5492879,
        substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
        substreamSpkg: "/primarypool.spkg",
        substreamModule: "map_subscriptions_per_pool",
        substreamProto: "/primarypool.proto",
        substreamMessage: "contract.v1.PrimaryPoolSubscriptionsList",
      },
      secondary: {
        substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
        substreamStartBlock: 6589966,
        substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
        substreamSpkg: "/secondarypool.spkg",
        substreamModule: "map_trades_per_pool",
        substreamProto: "/secondarypool.proto",
        substreamMessage: "contract.v1.SecondaryPoolTradeReportsList",
      },
      margin: {
        substreamEndpoint: "https://sepolia.substreams.pinax.network:443",
        substreamStartBlock: 5492908,
        substreamToken: process.env.REACT_APP_SUBSTREAM_TOKEN,
        substreamSpkg: "/marginpool.spkg",
        substreamModule: "map_trades_per_pool",
        substreamProtoUrl: "/marginpool.proto",
        substreamMessage: "contract.v1.MarginPoolTradeReportsList",
      },
    },
    paymentTokens: [],
    explorerApiKey: "M8SGUPC8CXRTER5GGTSSXW7C9A1ZINWWYA",
    explorerApiUrl: "https://api.etherscan.io/v2/api",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    brokerages: {
      HYPERLIQUID: "0x56eFa3AA1D26DF7856dB81aD29F19e091351eA52",
    },
    cfdEscrow: "0x7937A272add73fF8d3E956810F8E5228FdB8895F",
  },
};
